import { NativeSelect } from "@/components/ui/native-select";
import { CompareMetricSelect } from "./CompareMetricSelect";
import "./quiet-chart.css";

export interface QuietChartMetricOption {
  key: string;
  label: string;
}

export interface QuietChartHeaderProps {
  title: string;
  showComparison?: boolean;
  headingLevel?: "h1" | "h2";
  value: string;
  unit: string;
  metrics: QuietChartMetricOption[];
  selected: string;
  onMetric: (key: string) => void;
  comparison: string;
  onComparison: (key: string) => void;
  comparisonValue: string;
  comparisonUnit: string;
  color?: string;
  comparisonColor?: string;
  range: string;
  onRange: (value: string) => void;
}

export function QuietChartHeader({
  title, showComparison = true, headingLevel: Title = "h1",
  value,
  unit,
  metrics,
  selected,
  onMetric,
  comparison, onComparison, comparisonValue, comparisonUnit, color, comparisonColor,
  range,
  onRange,
}: QuietChartHeaderProps) {
  const selectedLabel =
    metrics.find((metric) => metric.key === selected)?.label ?? selected;

  return (
    <header className="quiet-chart-header">
      <Title className="quiet-chart-header__title">{title}</Title>

      <div className="quiet-chart-header__controls">
        <div className="quiet-chart-header__field">
          <label
            className="quiet-chart-header__label"
            htmlFor="quiet-chart-metric"
          >
            Metric
          </label>
          <NativeSelect
            id="quiet-chart-metric"
            className="quiet-chart-header__select"
            value={selected}
            onChange={(event) => onMetric(event.target.value)}
          >
            {metrics.map((metric) => (
              <option key={metric.key} value={metric.key}>
                {metric.label}
              </option>
            ))}
          </NativeSelect>
        </div>

        {showComparison && <CompareMetricSelect options={metrics.filter(metric=>metric.key!==selected)} value={comparison} onChange={onComparison}/>}
        <div className="quiet-chart-header__field">
          <label
            className="quiet-chart-header__label"
            htmlFor="quiet-chart-range"
          >
            Chart date range
          </label>
          <NativeSelect
            id="quiet-chart-range"
            className="quiet-chart-header__select"
            value={range}
            onChange={(event) => onRange(event.target.value)}
          >
            <option value="all">All history</option>
            <option value="90">90 days</option>
            <option value="30">30 days</option>
          </NativeSelect>
        </div>
      </div>

      <div className="quiet-chart-header__metric"><p className="quiet-chart-reading">
        <i className="quiet-chart-dot" style={{background:color}}/>
        <span className="quiet-chart-header__metric-name">{selectedLabel}</span>
        <span className="quiet-chart-header__metric-value">{value}</span>
        {unit ? (
          <span className="quiet-chart-header__metric-unit">{unit}</span>
        ) : null}
      </p>
      {comparison && <p className="quiet-chart-reading"><i className="quiet-chart-dot" style={{background:comparisonColor}}/><span className="quiet-chart-header__metric-name">{metrics.find(metric=>metric.key===comparison)?.label}</span><span className="quiet-chart-header__metric-value">{comparisonValue}</span><span className="quiet-chart-header__metric-unit">{comparisonUnit}</span></p>}
      </div>
    </header>
  );
}
